import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DragulaModule } from 'ng2-dragula';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxSmartModalModule, NgxSmartModalService } from 'ngx-smart-modal';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SxfDesignerService } from './services/sxfdesigner-service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { SxDesigner } from './components/main/designer.component';
import { SxDesignerMenuComponent } from './components/main/designer.menu.component';


import { SxMarcaDesigner } from './components/designers/layout/deprecated/marca.designer.component';
import { SxEmailDesigner } from './components/designers/layout/deprecated/email.designer.component';
import { SxSeparatorDesigner } from './components/designers/layout/text-editors/separator.designer.component';
import { SxTitleDesigner } from './components/designers/layout/text-editors/title.designer.component';
import { SxSimpleContainerDesigner } from './components/designers/layout/containers/simple-container.designer.component';
import { SxGroupDesigner } from './components/designers/layout/containers/group.designer.component';
import { SxPanelDesigner } from './components/designers/layout/containers/panel.designer.component';
import { SxModalDesigner } from './components/designers/layout/containers/modal-designer.component';
import { SxMainContainer } from './components/main/main-container.component';
import { SxColumnsDesigner } from './components/designers/layout/containers/columns-designer-component';
import { SxCustomControl } from './components/designers/custom/custom-control-designer.component';

import { IDesignerFactoryService } from './services/designer-factory-interface';
import { DesignerFactoryService } from './services/designer-factory-service';
import {
  ControlSourceTypePipe,
  ControlSafeHtmlPipe
} from './components/shared/control-source-type-pipe';
import { SxParagraphDesigner } from './components/designers/layout/text-editors/paragraph-designer-component';
import { UnknownDesignerComponent } from './components/designers/layout/deprecated/unknowDesigner.component';
import { SxImageDesigner } from './components/designers/layout/files-manager/imageDesigner.component';
import { SxImageAssetPickerComponent } from './components/shared/imageAssetPicker.component';
import { SxAssetInputComponent } from './components/shared/asset-input.component';
import { SxAttributeList } from './components/designers/layout/flow-actions/attributeListDesigner.component';
import { SxFileSelectorDesigner } from './components/designers/layout/files-manager/fileSelectorDesigner.component';
import { SxFileExportGroupDesigner } from './components/designers/layout/files-manager/fileExportGroup.designer.component';
import { SxFileImportDesigner } from './components/designers/layout/files-manager/fileImport.designer.component';
import { SxTextModalComponent } from './components/shared/modal.text.component';
import { MappingPaymentComponent } from '../paymentGateways/mapping/mapping.payment.component';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { DynamicStyleComponent } from './components/shared/dynamicStyle.component';
import { SxColumnsModalAdvancedComponent } from './components/modals/tabs/advanced/columns-modal-advanced.component';
import { SxColumnsModalGeneralComponent } from './components/modals/tabs/general/columns-modal-general.component';
import { ColumnsService } from './services/columns-service';
import { SxConfigModalComponent } from './components/modals/config-modal.component';
import { SxListModalComponent } from './components/modals/list-modal.component';
import { SxPageModalComponent } from './components/modals/page-modal.component';
import { SxRuleModalComponent } from './components/modals/rule-modal.component';
import { SxAttributeModalComponent } from './components/modals/attribute-modal.component';
import { SxSideBarDesignerComponent } from './components/main/sidebar.component';
import { SxInternalStateDesignerService } from './services/internal-state-designer-service';
import { SxViewEngine } from './components/designers/view-engine/viewEngine.component';
import { OutputsViewEngineComponent } from './components/modals/view-engine/tabs/outputs/outputs-view-engine.component';
import { SxViewEngineModalComponent } from './components/modals/view-engine/view-engine-modal.component';
import { SxQuotationResultDesigner } from './components/designers/layout/flow-actions/quotationResultDesigner.component';
import { SxAsyncQuotationResultDesigner } from './components/designers/layout/flow-actions/quotationResultAsyncDesigner.component';
import { SxSyncCandidatesDesigner } from './components/designers/layout/flow-actions/syncCandidatesDesigner.component';
import { SxPaymentGatewayDesigner } from './components/designers/layout/flow-actions/paymentGatewayDesigner.component';
import { SxActionButtonComponent } from './components/designers/layout/flow-actions/actionbuttonDesigner.component';
import { AttributesFilterPipe } from './pipes/attributes-filter.pipe';
import { OverViewComponent } from './components/modals/view-engine/tabs/over-view/overview-view-engine.component';
import { InputComponent } from 'app/helpers/components/formWidgets/input.component';
import { InputsViewEngineComponent } from './components/modals/view-engine/tabs/inputs/inputs-view-engine.component';
import { SxDynamicAttributeContainerDesigner } from './components/designers/layout/containers/dynamicAttributeContainer.designer.component';
import { SxRedirecPGDesigner } from './components/designers/layout/flow-actions/redirectPaymentGateway.component';
import { SxCreateFlowModalComponent } from './components/modals/create-flow/create-flow-modal.component';
import { SxGroupCollapsibleDesigner } from './components/designers/layout/containers/group-collapsible.designer.component';
import { FunctionsViewEngineComponent } from './components/modals/view-engine/tabs/functions/functions-view-engine.component';
import { FunctionsCodeModalComponent } from './components/modals/view-engine/tabs/functions/functions-code-modal.component';
import { DependenciesVEComponent } from './components/modals/view-engine/tabs/dependencies/dependencies-view-engine.component';

const COMPONENTS = [
  SxMainContainer,
  SxMarcaDesigner,
  SxEmailDesigner,
  SxSeparatorDesigner,
  SxTitleDesigner,
  SxSimpleContainerDesigner,
  SxDynamicAttributeContainerDesigner,
  SxGroupDesigner,
  SxGroupCollapsibleDesigner,
  SxPanelDesigner,
  SxModalDesigner,
  SxColumnsDesigner,
  SxCustomControl,
  SxParagraphDesigner,
  SxQuotationResultDesigner,
  SxAsyncQuotationResultDesigner,
  SxSyncCandidatesDesigner,
  SxViewEngine,
  SxPaymentGatewayDesigner,
  SxRedirecPGDesigner,
  SxImageDesigner,
  SxImageAssetPickerComponent,
  SxActionButtonComponent,
  SxAttributeList,
  SxFileSelectorDesigner,
  SxFileExportGroupDesigner,
  SxFileImportDesigner,
  SxTextModalComponent,
  MappingPaymentComponent,
  SxColumnsModalAdvancedComponent,
  SxColumnsModalGeneralComponent,
  SxConfigModalComponent,
  SxListModalComponent,
  SxPageModalComponent,
  SxRuleModalComponent,
  SxAttributeModalComponent,
  SxSideBarDesignerComponent,
  OverViewComponent,
  OutputsViewEngineComponent,
  InputsViewEngineComponent,
  SxCreateFlowModalComponent,
  SxViewEngineModalComponent,
  FunctionsViewEngineComponent,
  FunctionsCodeModalComponent,
  DependenciesVEComponent
];

export const sxfDesignerModule: NgModule = {
  declarations: [
    SxDesignerMenuComponent,
    SxDesigner,
    UnknownDesignerComponent,
    ControlSourceTypePipe,
    ControlSafeHtmlPipe,
    SxAssetInputComponent,
    SxTextModalComponent,
    MappingPaymentComponent,
    DynamicStyleComponent,
    AttributesFilterPipe,
    ...COMPONENTS
  ],
  providers: [
    ColumnsService,
    SxfDesignerService,
    NgxSmartModalService,
    {
      provide: IDesignerFactoryService,
      useClass: DesignerFactoryService
    },
    SxInternalStateDesignerService
  ],
  imports: [
    NgbModule,
    FormsModule,
    DragulaModule,
    BrowserAnimationsModule,
    NgxSmartModalModule.forRoot(),
    MultiselectDropdownModule,
    SelectDropDownModule,
    ColorPickerModule
  ],
  entryComponents: COMPONENTS,
  exports: [ControlSourceTypePipe, ControlSafeHtmlPipe]
};



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/sxfdesigner.module.ts